import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../shared/services/admin/admin.service';
import { EventService } from './../../shared/services/event/event.service';

@Component({
  selector: 'ngx-mode-maintenance',
  templateUrl: './mode-maintenance.component.html',
  styleUrls: ['./mode-maintenance.component.scss']
})
export class ModeMaintenanceComponent implements OnInit, OnDestroy {
  checkModeMaintenance: NodeJS.Timeout;
  modeMaintenanceInfo: any;

  constructor(private readonly eventService: EventService,
    private readonly adminService: AdminService,
    private readonly router: Router) {
    this.modeMaintenanceInfo = this.router.getCurrentNavigation().extras;
    this.launchCheck();
  }

  ngOnDestroy(): void {
    this.eventService.broadcast('modeMaintenance', false);
    clearInterval(this.checkModeMaintenance);
  }

  ngOnInit() {
    this.eventService.broadcast('modeMaintenance', true);
    this.checkModeMaintenance = setInterval(() => {
      this.launchCheck();
    }, 60000);
  }

  launchCheck() {
    this.adminService.isModeMaintenance$().subscribe((isModeMaintenanceDisabled) => {
      if (isModeMaintenanceDisabled) {
        this.eventService.broadcast('modeMaintenance', false);
        this.router.navigate(['/']);
      }

    }, err => {
      const modeMaintenaceInfoTemp = JSON.parse(err.message).message.split('#')[1];
      this.modeMaintenanceInfo = JSON.parse(modeMaintenaceInfoTemp);
    });
  }

}
